export const toArray = <T>(maybeArray: T | T[] = []): T[] => ([] as T[]).concat(maybeArray);
